import React from 'react';
import { Button } from 'antd';
import { HeartFilled } from '@ant-design/icons';
import VideoPlayer from '../../../components/VideoPlayer';
import { LocalizationContext } from '../../../hoc/Localization';
import { RouteContext } from '../../../hoc/Route';
import { SecurityContext } from '../../../hoc/Security';
import { UserContext } from '../../../hoc/User';
import { SettingsContext } from '../../../hoc/Settings';
import Loading from '../../Loading';
import { getCourses, toggleFavourite } from '../../../utils/directory';
import api, { getPath } from '../../../utils/api';
import SchoolLink from '../../TinyComponents/SchoolLink';
import SalaryRangeWeb from './SalaryRangeWeb/salaryRangeWeb';
import SalaryRangeMobile from './SalaryRangeMobile/salaryRangeMobile';
import Container from '../../Home/Container';
import TitleContent from '../../TinyComponents/TitleContent';
import CardListHeaderPath from '../../CardListPath/Header/HeaderPath';
import CardListHeader from '../../CardListPath/Header';
import CardList from '../../CardListPath';
import CardListJob from '../../CardListJob';
import IconCard from '../../TinyComponents/IconCard';
import Professions from './Professions';
import { pathVisited } from '../../../utils/events/paths';
import MarkDown from '../../TinyComponents/MarkDown';
import styles from './styles.less';

const Path = () => {
    const { t, locale } = React.useContext(LocalizationContext);
    const { params } = React.useContext(RouteContext);
    const { favourite: favouriteClicked, setFavourite } = React.useContext(SecurityContext);
    const { user, refreshUser } = React.useContext(UserContext);
    const {
        domainSettings: { domain },
    } = React.useContext(SettingsContext);

    const [isFavourite, setIsFavourite] = React.useState(false);
    const [screenSize, setScreenSize] = React.useState();
    const [loading, setLoading] = React.useState(true);
    const [courses, setCourses] = React.useState([{}, {}, {}]);
    const [competence, setCompetence] = React.useState('');
    const [videoLoading, setVideoLoading] = React.useState(true);
    const [path, setPath] = React.useState();
    const [width, setWidth] = React.useState();
    const [loadingFavourite, setLoadingFavourite] = React.useState(false);
    const [jobsData, setJobsData] = React.useState();

    const filters = {
        sort: 'relevance',
        page: 1,
        countries: ['Armenia'],
    };

    const resize = () => {
        if (window.innerWidth <= 991 && screenSize !== 'mobile') {
            setScreenSize('mobile');
        }
        if (window.innerWidth > 991 && screenSize !== 'web') {
            setScreenSize('web');
        }
    };

    React.useEffect(() => {
        if (favouriteClicked && user) {
            setFavourite(false);
            // eslint-disable-next-line no-use-before-define
            handleFavouriteClick();
        }
    }, [favouriteClicked, user]);

    React.useEffect(() => {
        (async () => {
            // @TODO: we fetch path in pages/paths to catch/show 404 if not found, please use try to use already fetched path
            const fetchedPath = (await getPath(params.id)).data;
            setPath(fetchedPath);
            setLoading(false);
            pathVisited(fetchedPath, domain);
            window.scrollTo({ top: 0 });
        })();
    }, [params.id]);

    React.useEffect(() => {
        setWidth(window.innerWidth);
    }, []);

    React.useEffect(() => {
        if (path && path.competences && path.competences[0]) {
            setCompetence(path.competences[0][`title_${locale}`]);
        }
        if (path) {
            (async () => {
                setJobsData(
                    (
                        await api.post('/pathJobs', {
                            page: 1,
                            keyWords: path.jobKeyWords,
                        })
                    ).data,
                );
            })();
        }
    }, [path]);

    React.useEffect(() => {
        if (path && user) {
            setIsFavourite(user.favouritePaths.find(e => e.path_id === path.id));
        }
    }, [path, user]);

    React.useEffect(() => {
        const modifiedFilters = { ...filters };
        if (competence) {
            modifiedFilters.search = competence;
            (async () => {
                setCourses((await getCourses({ filters: modifiedFilters })).data);
            })();
        }
    }, [competence]);

    React.useEffect(() => {
        window.addEventListener('resize', resize);
        if (window.innerWidth < 991) {
            setScreenSize('mobile');
        } else {
            setScreenSize('web');
        }
    }, []);

    async function handleFavouriteClick() {
        if (user && !loadingFavourite) {
            setLoadingFavourite(true);
            await toggleFavourite(path.id, isFavourite, 'path');
            await refreshUser();
            setLoadingFavourite(false);
        }
        if (!user) {
            setFavourite(true);
        }
    }

    const handleFilterChange = optionId => {
        const selectedCompetence = path.competences.filter(o => o.id === optionId)[0];
        setCompetence(selectedCompetence[`title_${locale}`]);
    };

    return (
        <div className={styles.pathContainer}>
            {loading ? (
                <Loading full />
            ) : (
                <>
                    {path ? (
                        <>
                            <div className={styles.coverWrapper}>
                                <img className={styles.cover} src={path.image} alt="pathImage" />
                                <div className={styles.CoverContent}>
                                    <div>
                                        <SchoolLink
                                            textClassName="path"
                                            className="schoolTitlePath"
                                            school={path.school}
                                        />
                                        <h1>{path.title}</h1>
                                    </div>
                                    <div className={styles.coverIcons}>
                                        <img src="/static/images/path/eye.svg" alt="eye" />
                                        <p>{path.views}</p>
                                        <p>{t('path.views')}</p>
                                        <Button
                                            className={styles.button}
                                            icon={
                                                <HeartFilled
                                                    style={{ fontSize: '20px' }}
                                                    className={isFavourite && styles.favourite}
                                                />
                                            }
                                            onClick={() => handleFavouriteClick()}
                                        >
                                            {t('favourite.this')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <Container className={styles.pathContainer}>
                                <div className={styles.grid}>
                                    <section className={styles.item1}>
                                        {screenSize === 'mobile' && (
                                            <SalaryRangeMobile
                                                salary={path && path.salary[0] && path.salary}
                                            />
                                        )}
                                        {screenSize === 'web' && (
                                            <SalaryRangeWeb
                                                salary={path && path.salary[0] && path.salary}
                                            />
                                        )}
                                    </section>
                                    <section className={styles.item2}>
                                        <h3>{t('about.path')}</h3>
                                        <MarkDown source={path[`about_${locale}`]} />
                                    </section>
                                </div>
                                <section>
                                    <TitleContent
                                        title={
                                            <CardListHeaderPath
                                                title={t('courses.path')}
                                                options={path.competences}
                                                onChange={handleFilterChange}
                                            />
                                        }
                                        content={
                                            <CardList
                                                data={courses}
                                                type="path"
                                                noButton
                                                reference="path"
                                                linkOptions={{ search: competence }}
                                            />
                                        }
                                    />
                                </section>
                                {!!(jobsData && jobsData.total) && (
                                    <section>
                                        <TitleContent
                                            title={<CardListHeader title={t('jobs.path')} />}
                                            content={
                                                <CardListJob
                                                    data={jobsData.jobs}
                                                    type="course"
                                                    reference="path"
                                                />
                                            }
                                        />
                                    </section>
                                )}
                                <section>
                                    <div className={styles.iconCards}>
                                        <IconCard
                                            title={t('paths.title.cv')}
                                            text={t('paths.cv.text')}
                                            icon="/static/images/path/cv.svg"
                                            search="CV"
                                        />
                                        <IconCard
                                            title={t('paths.title.interview')}
                                            text={t('paths.interview.text')}
                                            icon="/static/images/path/skills.svg"
                                            search="HR"
                                        />
                                        <IconCard
                                            title={t('paths.title.skills')}
                                            text={t('paths.skills.text')}
                                            icon="/static/images/path/cv.svg"
                                            search="Web"
                                        />
                                    </div>
                                </section>
                                <section>
                                    <div className={styles.videoWrapper}>
                                        <div className={styles.videoText}>
                                            <h2>{t('path.video.title')}</h2>
                                            <MarkDown source={path[`videoText_${locale}`]} />
                                        </div>
                                        {path.videoUrl ? (
                                            <div className={styles.playerContainer}>
                                                {videoLoading ? (
                                                    <Loading className={styles.loading} />
                                                ) : null}
                                                <VideoPlayer
                                                    width={
                                                        width < 711 ? `${width * 0.9}px` : '640px'
                                                    }
                                                    height={
                                                        width < 711
                                                            ? `${(width * 0.9) / 1.78}px`
                                                            : '360px'
                                                    }
                                                    className={styles.player}
                                                    url={path.videoUrl}
                                                    onReady={() => {
                                                        setVideoLoading(false);
                                                    }}
                                                />
                                            </div>
                                        ) : null}
                                    </div>
                                </section>
                                {path.related && path.related[0] && (
                                    <section>
                                        <h2>{t('related.professions')}</h2>
                                        <div className={styles.professions}>
                                            {path.related.map(p => (
                                                <Professions
                                                    key={p.id}
                                                    id={p.id}
                                                    image={p.image}
                                                    title={p[`title_${locale}`]}
                                                    profession={p.profession[`title_${locale}`]}
                                                    description={
                                                        p[`description${locale}`] || p.description
                                                    }
                                                />
                                            ))}
                                        </div>
                                    </section>
                                )}
                            </Container>
                        </>
                    ) : (
                        <div className={styles.resultNotificationGeneral}>
                            <h2>{t('noresults.header')}</h2>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Path;
